import { render, staticRenderFns } from "./Fip.vue?vue&type=template&id=8bcc539c&scoped=true&"
import script from "./Fip.vue?vue&type=script&lang=js&"
export * from "./Fip.vue?vue&type=script&lang=js&"
import style0 from "./Fip.vue?vue&type=style&index=0&id=8bcc539c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcc539c",
  null
  
)

export default component.exports